module.exports = __webpack_public_path__ + "img/post0.b5f7482f.png";